import './Trending.css';
import { useEffect, useState } from 'react';
import axios from 'axios';
import SingleContent from '../../components/SingleContent/SingleContent';
import CustomPagination from "../../components/Pagination/CustomPagination";

const Trending = () => {

    const [page, setPage] = useState(1);
    const [content, setContent] = useState([]);

    //define function to get movie data
    const fetchTrending = async () => {
        const {data} = await axios.get(
            `https://api.themoviedb.org/3/trending/all/day?api_key=0fbe97c924ca2542fd6812bd2897b386&page=${page}`
        );

        setContent(data.results);
    }

    //actually run the fetching data function
    useEffect(()=> { 
        fetchTrending();
        // eslint-disable-next-line
    },[page]);

    //movies use 'title', tv-shows use 'name'
    //movies use 'release date', tv-shows use 'first air date'
    return (  
    <div>
        <span className="pageTitle">Trending</span>
        <div className="trending">
            {content && content.map((c)=>(
                <SingleContent
                    key={c.id}
                    id={c.id}
                    poster={c.poster_path}
                    title={c.title || c.name}
                    date={c.first_air_date || c.release_date}
                    media_type={c.media_type}
                    vote_average={c.vote_average}
                />
            ))}
        </div>
        <CustomPagination setPage={setPage} />
    </div>
    );
}
 
export default Trending;